export const sortDataAccordingItemMovement = (event, data) => {
    const { oldIndex, newIndex } = event;
    if (!data ||
        oldIndex === newIndex ||
        typeof oldIndex === 'undefined' ||
        typeof newIndex === 'undefined') {
        return;
    }
    const newData = [...data];
    // Remove the item from the old index
    const [movedItem] = newData.splice(oldIndex, 1);
    // Insert the item at the new index
    newData.splice(newIndex, 0, movedItem);
    return newData;
};
